/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Emitter from 'tiny-emitter';
import { createStore } from 'vuex';

import auth from './authConfig.js';
import apiService from './api/api.service.js';
import formatHelpers from './helpers/formatHelpers.js';
import routeHelpers from './helpers/routeHelpers.js';
import loanHelpers from './helpers/loanHelpers';

const store = createStore({
  state() {
    return {
      alerts: [],
      attachments: [],
      conditions: [],
      conditionTemplates: [],
      documents: [],
      errorAlert: false,
      errorMsg: '',
      errorTitle: '',
      isLoanLocked: false,
      loanLockDialogOpened: false,
      notification: '',
      shareSessionId: null,
      unacknowledgedAlertCount: 0,
      alertsLoaded: false,
    }
  },
  mutations: {
    updateAttachments(state, atts) {
      state.attachments = atts;
    },
    updateConditions(state, conds) {
      state.conditions = conds;
    },
    updateConditionTemplates(state, conds) {
      state.conditionTemplates = conds;
    },
    updateDocuments(state, docs) {
      state.documents = docs;
    },
    updateIsLoanLocked(state, locked) {
      state.isLoanLocked = locked;
    },
    updateLoanLockDialogOpened(state, opened) {
      state.loanLockDialogOpened = opened;
    },
    updateSelectedLoan(state, loan) {
      state.selectedLoan = loan;
    },
    updateErrorAlert(state, errorData) {
      state.errorMsg = errorData.msg;
      state.errorTitle = errorData.title;
      state.errorAlert = errorData.isError;
    },
    updateNotification(state, notification) {
      state.notification = notification;
    },
    setShareSessionId(state, id) {
      state.shareSessionId = String(id || '').trim();
    },
    updateAlerts(state, alerts) {
      state.alerts = alerts;
      state.alertsLoaded = true;
    },
    updateAlertCount(state, count) {
      state.unacknowledgedAlertCount = count;
    },
    markAlertAcknowledged(state, alertId) {
      const alert = state.alerts.find(a => a.id === alertId);
      if (alert) {
        alert.acknowledged = true;
        state.unacknowledgedAlertCount = Math.max(0, state.unacknowledgedAlertCount - 1);
      }
    },
  },
  actions: {
    async addCondition({ commit, store, dispatch }, newCondition) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();

      return apiService.AddCondition(loanId, newCondition.bySwift, newCondition, tokenResponse.accessToken)
        .then(res => {
        }).catch(error => {
          console.log(error);
          let errorText = '';

          if (error.response?.data?.data) {
            errorText = "Error: \n\n" + error.response?.data?.data;
          }

          let errorData = {
            isError: true,
            title: 'Failed to Fetch Attachments',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async addConditionAndTracking({ commit, store }, newConditionData) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();

      return apiService.AddConditionAndTracking(loanId, newConditionData.bySwift, newConditionData, tokenResponse.accessToken)
        .then(res => {
        }).catch(error => {
          console.log(error);
          let errorText = '';

          if (error.response?.data?.data) {
            errorText = "Error: \n\n" + error.response?.data?.data;
          }

          let errorData = {
            isError: true,
            title: 'Failed to Fetch Attachments',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async getAttachments({ commit, store }) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();

      return apiService.getAttachments(loanId, tokenResponse.accessToken)
        .then(res => {
          let attachments = res.data.data;

          attachments.forEach(att => {
            if (!att.assignedTo) {
              att.assignedTo = { entityId: '', entityName: 'Unassigned' };
              att.assignedToName = 'Unassigned';
            } else {
              att.assignedToName = att.assignedTo.entityName;
            }

            att.createdDateTime = formatHelpers.formatDateTime(att.createdDate);
            att.createdDate = formatHelpers.formatDate(att.createdDate);
            att.addedBy = att.createdBy.entityId;
          });

          attachments.sort((a, b) => b.createdDateTime - a.createdDateTime);

          commit('updateAttachments', attachments);

        }).catch(error => {
          console.log(error);
          let errorText = '';

          if (error.response?.data?.data) {
            errorText = "Error: \n\n" + error.response?.data?.data;
          }

          let errorData = {
            isError: true,
            title: 'Failed to Fetch Attachments',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async getClearToCloseLetter({ commit, store, dispatch }) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();
      let letterRequest = sessionStorage.getItem('letterdata');
      if (letterRequest) {
        letterRequest = JSON.parse(letterRequest);
      }

      return apiService.GetClearToCloseLetter(loanId, letterRequest, tokenResponse.accessToken)
        .then(async res => {
          await dispatch('getAttachments');
          await dispatch('getDocuments');
          commit('updateNotification', 'Your Decision Letter has been placed in the eFolder');
        }).catch(error => {
          console.log(error);

          let errorMsg = error?.response?.data?.data ?? 'Please try again';

          let errorText = "Error: \n\n" + errorMsg;

          let errorData = {
            isError: true,
            title: 'Failed to Generate Decision Letter',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async getCondlApprovalLetter({ commit, store, dispatch }) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();
      let letterRequest = sessionStorage.getItem('letterdata');
      if (letterRequest) {
        letterRequest = JSON.parse(letterRequest);
      }

      return apiService.GetCondlApprovalLetter(loanId, letterRequest, tokenResponse.accessToken)
        .then(async res => {
          await dispatch('getAttachments');
          await dispatch('getDocuments');
          commit('updateNotification', 'Your Decision Letter has been placed in the eFolder');
        }).catch(error => {
          console.log(error);
          let errorMsg = error?.response?.data?.data ?? 'Please try again';

          let errorText = "Error: \n\n" + errorMsg;

          let errorData = {
            isError: true,
            title: 'Failed to Generate Decision Letter',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async getConditions({ commit, store }) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();

      return apiService.getConditions(loanId, tokenResponse.accessToken)
        .then(res => {
          res.data.data.forEach(cond => {
            cond.selected = false;
            cond.lastModifiedDate = formatHelpers.formatDate(cond.lastModifiedDate);
            cond.createdDate = formatHelpers.formatDateTime(cond.createdDate);
            cond.addedBy = cond.createdBy.entityId;

            let titleAndCode = formatHelpers.getTitleAndCode(cond.title);

            cond.formattedTitle = titleAndCode.title;

            cond.tracking = cond.tracking ? cond.tracking : [];

            if (cond.tracking.length > 0) {
              cond.lastTracking = formatHelpers.getLastTracking(cond.tracking);
              cond.cleared = cond.tracking.some(track => formatHelpers.clearedTrackingNames.some(name => name === track.status));
            } else {
              cond.cleared = false;
            }
          });

          commit('updateConditions', res.data.data);
        }).catch(error => {
          console.log(error);
          let errorText = '';

          if (error.response?.data?.data) {
            errorText = "Error: \n\n" + error.response?.data?.data;
          }

          let errorData = {
            isError: true,
            title: 'Failed to Fetch Conditions',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async getConditionTemplates({ commit, store }) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      return apiService.GetConditionTemplates(tokenResponse.accessToken)
        .then((res) => {
          commit('updateConditionTemplates', res.data.data);
        }).catch(error => {
          console.log(error);
          let errorText = '';

          if (error.response?.data?.data) {
            errorText = "Error: \n\n" + error.response?.data?.data;
          }

          let errorData = {
            isError: true,
            title: 'Failed to Fetch Conditions',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async getDocuments({ commit, store }) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();

      return apiService.getDocuments(loanId, tokenResponse.accessToken)
        .then((res) => {
          let documents = res.data.data.filter(doc => doc.title !== '* AIQ Upload' && doc.title !== 'zUploaded_to_AIQ').map(doc => ({ ...doc }));

          documents.forEach(doc => {
            doc.createdDate = formatHelpers.formatDate(doc.createdDate);
            doc.statusDate = formatHelpers.formatDate(doc.statusDate);
            doc.status = doc.status?.charAt(0).toUpperCase() + doc.status?.slice(1);
            doc.addedBy = doc.createdBy?.entityId;
          });

          commit('updateDocuments', documents);
        }).catch(error => {
          console.log(error);
          let errorText = '';

          if (error.response?.data?.data) {
            errorText = "Error: \n\n" + error.response?.data?.data;
          }

          let errorData = {
            isError: true,
            title: 'Failed to Fetch Documents',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async getLoanLock({ commit, store, dispatch }) {
      let tokenResponse = await auth.acquireTokenResponse();
      let loanId = routeHelpers.getLoanId();

      return apiService.GetLoanLock(loanId, tokenResponse.accessToken)
        .then((res) => {
          commit('updateIsLoanLocked', res.data.data);
        }).catch(error => {
          console.log(error);
        });
    },
    async getSuspensLetter({ commit, store, dispatch }) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();
      let letterRequest = sessionStorage.getItem('letterdata');
      if (letterRequest) {
        letterRequest = JSON.parse(letterRequest);
      }

      return apiService.GetSuspensLetter(loanId, letterRequest, tokenResponse.accessToken)
        .then(async res => {
          await dispatch('getAttachments');
          await dispatch('getDocuments');
          commit('updateNotification', 'Your Decision Letter has been placed in the eFolder');
        }).catch(error => {
          let errorMsg = error?.response?.data?.data ?? 'Please try again';

          let errorText = "Error: \n\n" + errorMsg;

          let errorData = {
            isError: true,
            title: 'Failed to Generate Decision Letter',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
async updateLoan({ commit, store }) {
  let tokenResponse = await auth.acquireTokenResponse();
  this.idTokenClaims = tokenResponse.idTokenClaims;

  let loanId = routeHelpers.getLoanId();

  return apiService.GetLoan(loanId, tokenResponse.accessToken)
    .then(async res => {
      loanHelpers.setLoanSessionData(res.data.data);

      try {
        const azureId =
          tokenResponse?.idTokenClaims?.oid ||
          tokenResponse?.idTokenClaims?.sub ||
          localStorage.getItem('azure_id');

        if (!azureId) return;

        const selectedLoanId = sessionStorage.getItem('selectedloan');
        if (!selectedLoanId) return;

        const lastUpsert = sessionStorage.getItem('recentloan_lastupsert');
        if (lastUpsert === String(selectedLoanId)) return;
        sessionStorage.setItem('recentloan_lastupsert', String(selectedLoanId));

        let letterData = sessionStorage.getItem('letterdata');
        letterData = letterData ? JSON.parse(letterData) : null;

        let loanData = sessionStorage.getItem('loandata');
        loanData = loanData ? JSON.parse(loanData) : null;

        const payload = {
          loanId: selectedLoanId,
          loanNumber: letterData?.loanNumber || sessionStorage.getItem('loannumber'),
          borrowerName: letterData?.loanBorrower || sessionStorage.getItem('loanborrower'),
          loanAmount: loanData?.loanAmount ?? null,
          cityState: loanData?.cityState ?? null
        };

        if (!payload.loanId || !payload.loanNumber || !payload.borrowerName) return;

        await apiService.UpsertRecentLoan(azureId, payload, tokenResponse.accessToken);
      } catch (e) {
        console.log('UpsertRecentLoan failed', e);
      }
    })
    .catch(error => {
      console.log(error);
    });
},
    async getLoanFields({ commit, store }, fieldsList) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      let loanId = routeHelpers.getLoanId();

      return apiService.GetLoanFieldList(loanId, fieldsList, tokenResponse.accessToken)
        .then(res => {
          return res.data.data;
        }).catch(error => {
          console.log(error);
        });
    },
    async runSwift({ commit, store }) {
      let tokenResponse = await auth.acquireTokenResponse();

      let loanId = routeHelpers.getLoanId();

      return apiService.ConditionLoan(loanId, tokenResponse.accessToken)
        .then(res => {
        }).catch(error => {
          console.log(error);

          let errorText = "Error: \n\n" + error.data;

          let errorData = {
            isError: true,
            title: 'Failed to Run SwiftAI',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    updateLoanLockDialogOpened({ commit }, opened) {
      commit('updateLoanLockDialogOpened', opened);
    },
    async upsertTask({ commit }, request) {
      let tokenResponse = await auth.acquireTokenResponse();
      this.idTokenClaims = tokenResponse.idTokenClaims;

      return apiService.UpsertTask(request, tokenResponse.accessToken)
        .then(res => {
        }).catch(error => {
          console.log(error);
          let errorText = '';

          if (error.response?.data?.data) {
            errorText = "Error: \n\n" + error.response?.data?.data;
          }

          let errorData = {
            isError: true,
            title: 'Failed to Update Task',
            msg: errorText
          };

          commit('updateErrorAlert', errorData);
        });
    },
    async getAlerts({ commit }) {
      let tokenResponse = await auth.acquireTokenResponse();
      let loanId = routeHelpers.getLoanId();

      return apiService.GetLoanAlerts(loanId, tokenResponse.accessToken)
        .then(res => {
          const alerts = res.data.data || [];
          commit('updateAlerts', alerts);

          const unacknowledgedCount = alerts.filter(a => !a.acknowledged).length;
          commit('updateAlertCount', unacknowledgedCount);
        })
        .catch(error => {
          console.error('Failed to fetch alerts:', error);
        });
    },
    async acknowledgeAlert({ commit }, alertId) {
      let tokenResponse = await auth.acquireTokenResponse();
      let loanId = routeHelpers.getLoanId();

      return apiService.AcknowledgeAlert(alertId, loanId, tokenResponse.accessToken)
        .then(res => {
          commit('markAlertAcknowledged', alertId);
        })
        .catch(error => {
          console.error('Failed to acknowledge alert:', error);
        });
    }
  }
});

const app = createApp(App);
app.use(router);
app.use(store);

router.isReady().then(() => {
  app.mount('#app');
})

const userId = localStorage.getItem('azure_id');

window.dataLayer.push({
  'event': 'login',
  'userId': userId //this number must be replaced with an actual User ID
})
//createApp(App).use(router).use(store).mount('#app');
